// extracted by mini-css-extract-plugin
export default {"pageContainer":"Cancel_pageContainer__nRcZO"};